<template>
  <div class="designfile-list">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-toolbar class="my-md-auto nobackground" elevation="0"  >
          <v-toolbar-title class="toolbartitle_50" >
            <h1><v-icon large>mdi-file-cad</v-icon>{{$t('designfile.designfiles')}}</h1>
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            :loading="isLoading"
            class="ml-sm-2"
            color="primary"
            v-if="userHasAccess('designfile_edit')"
            @click="addHandler"
          >
            {{ $t('global.add')}}
          </v-btn>
        </v-toolbar>
        <v-flex lg12>
          <v-container
             v-for="type in types"
             :key="type.id"
             class=""
             fluid
           >
             <v-subheader>
               <strong class="headline" v-if="language == 'fr'"> {{ type.namefr }}</strong>
               <strong  class="headline" v-else> {{ type.name }}</strong>
               <v-spacer></v-spacer>
               <v-btn
                 :loading="isLoading"
                 class="ml-sm-2 textresponsive"
                 color="primary"
                 @click="viewByType(type.id)"
               >
                 {{ $t('global.viewall')}}
               </v-btn>
             </v-subheader>

             <v-row v-if="itemsByType(type.id)">

               <v-col
                 v-for="designfile in itemsByType(type.id)"
                 :key="designfile.id"
                 cols="12"
                 sm="6"
                 md="4"
               >
                 <v-card class="black">
                   <v-img
                     v-if="designfile['image']"
                     :src="getImageUrlByObject(designfile)"
                     height="300"
                     @click="showHandler(designfile)"
                     :key="getItemImageKey(designfile)"
                     class="white--text align-end cursorpointer "
                     contain
                   >
<!--
                     <span
                       class="text-h5 white--text pl-4 pt-4 d-inline-block"
                       v-text="designfile.type.name"
                   ></span>
!-->
                   </v-img>
                   <v-img v-else height="300" contain @click="showHandler(designfile)" class="white--text align-center align-end cursorpointer  text-center" >
                     <p class="textsize20 text-uppercase ma-5 familyGTAmerica" >{{ $t('global.nopicture') }}<br>{{ $t('global.available') }}</p>
                   </v-img>

                   <v-card-actions class="bordertop_white">

                     <span class="ml-4 d-inline-block text-truncate" v-if="language == 'fr'">{{ designfile.namefr }}</span>
                     <span class="ml-4 d-inline-block text-truncate" v-else>{{ designfile.name }}</span>
                     <v-spacer></v-spacer>
                     <v-btn  icon x-large @click="showHandler(designfile)">
                       <v-icon>mdi-launch</v-icon>
                     </v-btn>
                   </v-card-actions>
                 </v-card>
               </v-col>
             </v-row>
           </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from '../../mixins/FileMixin';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'DesignFileList',
  servicePrefix: 'DesignFile',
  mixins: [ListMixin,AccessMixin,FileMixin],
  components: {

  },
  data() {
    return {
      filter: '400x400',
      filters: {
        'type' : null,
      },
      itemsType: [],
     }
  },
  mounted() {
    this.getTypes();

  },
  computed: {
    ...mapGetters('designfile', {
      designfiles: 'list'
    }),
    ...mapGetters('designfiletype', {
      types: 'list'
    }),
    ...mapFields('designfile', {
      isLoading: 'isLoading',
    }),
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions('designfile', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    ...mapActions('designfiletype', {
      getTypes: 'fetchAll',
      deleteItem: 'del'
    }),
    itemsByType(typeId) {
      return this.itemsType[typeId];
    },
    viewByType(typeId) {
      this.$router.push({ name: `DesignFileByTypeList` , params: { id: typeId }});
    },
  },
  watch: {

    types(types) {
      for (var i = 0; i < types.length; i++) {
        this.filters.type = types[i].id;
        this.options.page = 1;
        this.options.itemsPerPage = 3;
        this.onUpdateOptions(this.options);
      //  this.getPage();
      }

    },
    designfiles(items) {
      for (var y = 0; y < items.length; y++) {
        if (! Array.isArray(this.itemsType[items[y].type.id])) {
          this.itemsType[items[y].type.id] = [];
        }
        let exist= false;
        for (var i = 0; i < this.itemsType[items[y].type.id].length; i++) {
          if (this.itemsType[items[y].type.id][i].id == items[y].id) {
            exist = true;
          }
        }
        if (! exist) {
          this.itemsType[items[y].type.id].push(items[y]);
        }
      }
    }
  }
};
</script>
